import { lazy, Suspense, useEffect } from "react";
import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";
import Navbar from "./Component/Navbar";
import Footer from "./Component/Footer";
import { ThemeProvider } from "./Component/ThemeContext";

const Home = lazy(() => import("./Component/Home"));
const Aboutus = lazy(() => import("./Component/Aboutus"));
const Contactus = lazy(() => import("./Component/Contactus"));
const Companyregistration = lazy(() => import("./Component/Companyregistration"));
const TokenizedGoldPage = lazy(() => import("./Component/Tokenizegold"));
const Tokenizegold2 = lazy(() => import("./Component/Tokenizegold2"));
const Digitalgold = lazy(() => import("./Component/Digitalgold"));
const CGO = lazy(() => import("./Component/CGO"));
const Feestructure = lazy(() => import("./Component/Feestructure"));
const Derisk = lazy(() => import("./Component/Derisk"));
const Transparency = lazy(() => import("./Component/Transparency"));
const Routine = lazy(() => import("./Component/Routine"));
const FAQs = lazy(() => import("./Component/FAQs"));
const Privacypolicy = lazy(() => import("./Component/Privacypolicy"));
const Blogs = lazy(() => import("./Component/Blogs"));
const RedirectApp = lazy(() => import("./Component/RedirectApp"));
const WhiteLabel = lazy(() =>
  import("./Component/WhiteLabel").then((m) => ({ default: m.WhiteLabel }))
);
const Disclaimers = lazy(() => import("./Component/Disclaimers"));
const ComplianceAMLPolicy = lazy(() => import("./Component/ComplianceAMLPolicy"));
const CgoTokenProofOfReserves = lazy(() => import("./Component/CgoTokenProofOfReserves"));
const Termsandconditions = lazy(() => import("./Component/Termsandconditions"));
const RiskDisclosure = lazy(() => import("./Component/RiskDisclosure"));
const Compliance = lazy(() => import("./Component/Compliance"));
const ProofOfGoldAudit = lazy(() => import("./Component/ProofOfGoldAudit"));
const Articles = lazy(() => import("./Component/Articles"));

const PageLoader = () => (
  <div className="d-flex justify-content-center align-items-center py-5">
    <div className="spinner-border text-primary" role="status">
      <span className="visually-hidden">Loading...</span>
    </div>
  </div>
);

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    const checkVersion = async () => {
      try {
        const response = await fetch("/version.json", {
          cache: "no-store",
        });
        const data = await response.json();
        const serverVersion = data.version;
        const localVersion = localStorage.getItem("app_version");
        if (!localVersion) {
          localStorage.setItem("app_version", serverVersion);
          return;
        }
        if (localVersion !== serverVersion) {
          localStorage.setItem("app_version", serverVersion);
          window.location.reload();
        }
      } catch (error) {
        console.error("Version check failed:", error);
      }
    };
    checkVersion();
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  const hideLayout = window.location.pathname === "/holi-festival";

  return (
    <ThemeProvider>
      <Router>
        <div>
          {!hideLayout && <Navbar />}
          <ScrollToTop />
          <Suspense fallback={<PageLoader />}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/Digitalgold" element={<Digitalgold />} />
              <Route path="/TokenizedGold" element={<TokenizedGoldPage />} />
              <Route path="/Exchanges&Wallets" element={<Tokenizegold2 />} />
              <Route path="/FAQs" element={<FAQs />} />
              <Route path="/Aboutus" element={<Aboutus />} />
              <Route path="/Blogs" element={<Blogs />} />
              <Route path="/Articles" element={<Articles />} />
              <Route path="/Contactus" element={<Contactus />} />
              <Route path="/Companyregistration" element={<Companyregistration />} />
              <Route path="/Privacypolicy" element={<Privacypolicy />} />
              <Route path="/Cgolistinglibrary" element={<CGO />} />
              <Route path="/Feestructure" element={<Feestructure />} />
              <Route path="/Deriskfromstablecoins" element={<Derisk />} />
              <Route path="/Transparency" element={<Transparency />} />
              <Route path="/Routine" element={<Routine />} />
              <Route path="/Disclaimers" element={<Disclaimers />} />
              <Route path="/ComplianceAMLPolicy" element={<ComplianceAMLPolicy />} />
              <Route path="/CgoTokenProofOfReserves" element={<CgoTokenProofOfReserves />} />
              <Route path="/TermsandConditions" element={<Termsandconditions />} />
              <Route path="/risk-disclosure" element={<RiskDisclosure />} />
              <Route path="/compliance" element={<Compliance />} />
              <Route path="/proof-of-gold-audit" element={<ProofOfGoldAudit />} />
              <Route path="/download" element={<RedirectApp />} />
              <Route path="/whitelabel" element={<WhiteLabel />} />
            </Routes>
          </Suspense>
          {!hideLayout && <Footer />}
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;
